'use client';

import styles from './QuestionnaireResponsiveNavigation.module.css';
import type { QuestionnaireResponsiveNavigationProps } from './QuestionnaireResponsiveNavigation.types';
import type { Section } from '@/_types/models/sections';
import { ClientQuestionnaireContext } from '@/_contexts/client/ClientQuestionnaireProvider';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { Flex } from '@/_components';
import { filterUploadOnlySections } from '@/_utils/sections';
import { useContext, type FC } from 'react';
import { QuestionnaireNavigationItem } from '@/_components/QuestionnaireNavigation/components/QuestionnaireNavigationItem';

export const QuestionnaireResponsiveNavigation: FC<
  QuestionnaireResponsiveNavigationProps
> = ({ className, onToggle }) => {
  const { selectedSections } = useContext(ClientQuestionnaireContext);
  const { preferences } = useContext(FirmSettingsContext);

  const filteredSections: Array<Section> = filterUploadOnlySections(
    selectedSections,
    !!preferences?.hide_document_uploads_within_sections,
  );

  return (
    <nav className={className} onClick={onToggle}>
      <Flex
        isColumn={true}
        padding={2}
        gap={2}
        className={styles.questionnaireResponsiveNavigation}
      >
        {filteredSections.map((section, key) => {
          return (
            <QuestionnaireNavigationItem
              mode="client"
              section={section}
              key={key}
            />
          );
        })}
      </Flex>
    </nav>
  );
};
